import { Button, Col, Card, CardBody } from "react-bootstrap";
import languageES from "datatables.net-plugins/i18n/es-MX";
import { useTranslation } from "react-i18next";
import { useEffect, useRef } from "react";
import api from "@/api/api.js";
import $ from "jquery";
import "datatables.net";
import { capitalizeFirstLetter } from "@/utils/stringUtils.js";
import { Link, useNavigate } from "react-router-dom";

const RequestTickets = () => {
  const { t } = useTranslation();
  const userId = sessionStorage.getItem("user");
  const tableRef = useRef(null);
  const dataTable = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!tableRef.current || !userId) return;
    const STYLE_ID = "approved-row-style";
    if (!document.getElementById(STYLE_ID)) {
      const styleEl = document.createElement("style");
      styleEl.id = STYLE_ID;
      styleEl.textContent = `
                /* Resaltar filas aprobadas */
                .approved-row { background-color: #e8f5e9 !important; }
                .not-approved-row { background-color: #fdecea !important; }
            `;
      document.head.appendChild(styleEl);
    }
    if ($.fn.DataTable.isDataTable(tableRef.current)) {
      $(tableRef.current).DataTable().clear().destroy();
      $(tableRef.current).empty();
    }
    dataTable.current = $(tableRef.current).DataTable({
      language: languageES,
      processing: true,
      serverSide: true,
      ajax: (dtParams, callback) => {
        api
          .get(`/request_tickets/${userId}/all`)
          .then(({ data }) => {
            callback({
              draw: dtParams.draw,
              recordsTotal: data["hydra:totalItems"],
              recordsFiltered: data["hydra:totalItems"],
              data: data["hydra:member"],
            });
          })
          .catch(() =>
            callback({
              draw: dtParams.draw,
              recordsTotal: 0,
              recordsFiltered: 0,
              data: [],
            }),
          );
      },
      createdRow: (row, rowData) => {
        try {
          console.log(rowData);
          if (rowData && rowData.approvalStatus == 1) {
            $(row).addClass("approved-row");
          }

          if (rowData && rowData.approvalStatus == 0) {
            $(row).addClass("not-approved-row");
          }
        } catch {
          /* noop */
        }
      },
      columns: [
        { title: capitalizeFirstLetter(t("folio")), data: "id" },
        {
          title: capitalizeFirstLetter(t("package adquired")),
          data: "packageName",
        },
        {
          title: capitalizeFirstLetter(t("requested by")),
          render: (data, type, row) => {
            return row.requestUser.userProfile.fullName;
          },
        },
        {
          title: capitalizeFirstLetter(t("approved by")),
          render: (data, type, row) => {
            return (
              row.approvedBy?.userProfile?.fullName ||
              '<span class="text-muted">Pendiente</span>'
            );
          },
        },
        {
          title: capitalizeFirstLetter(t("last modification")),
          data: "createdAtAgo",
        },
        {
          title: capitalizeFirstLetter(t("quantity bills")),
          data: "quantityTickets",
        },
        {
          title: capitalizeFirstLetter(t("acciones")),
          render: (data, type, row) => {
            const requestTicketId = row["@id"].split("/").pop();
            console.log("row: " + row.id);
            return `
                            <button class="btn btn-warning btn-detail-request-ticket" data-id="${requestTicketId}">Detalle</button>
                        `;
          },
        },
      ],
    });
    const handleShowClick = (event) => {
      const request_ticket_id = $(event.currentTarget).data("id");
      console.log("request_ticket_id: " + request_ticket_id);
      navigate(`/request_tickets/${request_ticket_id}/show`);
    };

    $(tableRef.current).on(
      "click",
      ".btn-detail-request-ticket",
      handleShowClick,
    );

    return () => {
      if ($.fn.DataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable().destroy();
      }
      $(tableRef.current).off(
        "click",
        ".btn-detail-request-ticket",
        handleShowClick,
      );
    };
  }, [userId, navigate]);
  return (
    <>
      <Col xs={12}>
        <Card>
          <Card.Header className="d-flex justify-content-between align-items-center">
            <span>Lista de paquetes comprados</span>
            <Link to="/buy_package" style={{ textDecoration: "none" }}>
              <Button variant="primary" size="sm">
                {capitalizeFirstLetter(t("buy package"))}
              </Button>
            </Link>
          </Card.Header>
          <CardBody>
            <table
              ref={tableRef}
              className="display"
              style={{ width: "100%" }}
            ></table>
          </CardBody>
        </Card>
      </Col>
    </>
  );
};

export default RequestTickets;
